import { LoadingAnimation } from './LoadingAnimation';
import './SidebarMenu.css';

export const SidebarMenuItem = ({ 
  label, 
  isActive = false, 
  isLoading = false, 
  onClick 
}) => {
  const handleClick = () => {
    if (!isLoading && onClick) {
      onClick();
    }
  };

  const getLabelClass = () => {
    if (isActive) return 'sidebar-menu-item__label sidebar-menu-item__label--active';
    if (isLoading) return 'sidebar-menu-item__label sidebar-menu-item__label--loading';
    return 'sidebar-menu-item__label sidebar-menu-item__label--default';
  };

  const itemClass = isLoading 
    ? 'sidebar-menu-item sidebar-menu-item--loading' 
    : 'sidebar-menu-item';

  return (
    <div className={itemClass} onClick={handleClick}>
      <div className="sidebar-menu-item__content">
        <span className={getLabelClass()}>{label}</span>
        {isLoading && <LoadingAnimation />}
      </div>
    </div>
  );
};

